import { lazy } from "react";

const TestSelectorLanguage = lazy( () => import(/* webpackChunkName: "SelectorLanguage" */ '../components/SelectorLanguage') )

const AgendaModule   = lazy( () => import(/* webpackChunkName: "Agenda"   */ '../modules/agenda') );
const checkoutModule = lazy( () => import(/* webpackChunkName: "Checkout" */ '../modules/checkout') );


export const routes = [
    {
        to: '/agenda/*',
        path: '/agenda/*',
        Component: AgendaModule,
        name: 'SelectorPage'
    },
    {
        to: '/checkout/*',
        path: '/checkout/*',
        Component: checkoutModule,
        name: 'SelectorPage'
    },
]